module.exports = __webpack_public_path__ + "static/media/bg2.84378183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg2.jpg
// module id = 5870
// module chunks = 0